<template>
  <div>logout template</div>
</template>

<script>
//----------------------
// scripts
//----------------------
import { mapActions } from 'vuex'

export default {
  name: 'logoutView',
  methods: {
    ...mapActions('auth', {
      userLogout: 'userLogout',
    }),
  },
  created() {
    this.userLogout().then(() => {
      console.log('logoutview.....')
      this.$router.push('/')
    })
  },
}
</script>
